import React from "react";
import { Box, Collapse } from "@mui/material";
import accountChild from "@iconify/icons-mdi/account-child";
import ApplicationCardInfoItem from "my-tax/components/application-card-info-item";
import ApplicationCollapseHeader from "my-tax/components/application-collapse-header";
import useStyles from "my-tax/components/dependents-collapse/dependents-collapse.style";
import { NOT_PROVIDED } from "my-tax/constants";
import { OcErrorBoundary } from "oc/components";
import { useRecoilState } from "recoil";
import { ocCollapseState } from "oc/states";

export const MyTaxDependentsFourChildrenCollapse = ({
  index,
  data,
  isMobile,
}: {
  index: number;
  data: {
    name?: string;
    taxNumber?: string;
    placeOfBirth?: string;
    dateOfBirth?: string | Date;
    mothersName?: string;
  };
  isMobile: boolean;
}) => {
  const [expanded, setExpanded] = useRecoilState(
    ocCollapseState(`leaveFilterCollapseExpanded${index}`)
  );

  const classes = useStyles(expanded);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <OcErrorBoundary>
      <Box>
        <ApplicationCollapseHeader
          handleExpandClick={handleExpandClick}
          expanded={expanded}
          icon={accountChild}
          dependentName={data?.name || ""}
          dependentTaxNumber={data?.taxNumber ? data?.taxNumber : NOT_PROVIDED}
          taxNumberLabel="Adóazonosító jele"
          isMobile={isMobile}
        />
        <Collapse in={expanded} timeout="auto">
          <Box className={classes.backgroundColor} padding="0px 16px">
            <Box className={classes.topBorder} />
            <Box display="flex" flexDirection="row" alignItems="center">
              <Box
                style={{
                  padding: "16px 0px",
                  marginRight: "8px",
                }}
              >
                <ApplicationCardInfoItem
                  label="Születési helye"
                  value={data?.placeOfBirth || ""}
                  isMobile={isMobile}
                />
                <ApplicationCardInfoItem
                  label="Születési ideje"
                  value={
                    data?.dateOfBirth
                      ? new Date(data?.dateOfBirth).toLocaleDateString()
                      : ""
                  }
                  isMobile={isMobile}
                />
                <ApplicationCardInfoItem
                  label="Anyja neve"
                  value={data?.mothersName || ""}
                  isMobile={isMobile}
                />
              </Box>
            </Box>
          </Box>
        </Collapse>
      </Box>
    </OcErrorBoundary>
  );
};

export default MyTaxDependentsFourChildrenCollapse;
